import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

type Args = {
  companyId: string
  topics: {
    topic_id: string
    topic: string
    region_code?: string
  }[]
}

export const handleGenerateBulkSEOGuidelines = async ({
  companyId,
  topics,
}: Args) => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-research/reports/bulk`
    const response = await axios.post(url, topics)
    return response
  } catch (error) {
    return extract.error(error)
  }
}

export const useGenerateBulkSeoGuidelines = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (args: Args) => handleGenerateBulkSEOGuidelines(args),
    onSuccess: () => {
      queryClient.invalidateQueries(['project-topics'])
    },
  })
}
